import React, { useEffect, useState } from "react";
import { Alert, Col, Row } from "reactstrap";

import { defineFieldWithChanges, isMultiDBObject } from "../../util/CompareJsonTools";
import { JS_INCOMPLETE_DATA, JS_ACTUAL_LB, JS_CAMBIOS_LB } from "../i18n/i18n";

import '../../../src/assets/css/JsonCompare.css'

const JsonCompare = props => {
    const { model='', actualData = {}, newData={} } = props

    const invalidInputs = (!actualData || !newData)
    const [fieldWithChanges, setFieldsWithChanges] = useState( [] )
    const [formatedActualData] = useState( isMultiDBObject(actualData) ? actualData['item'] : actualData )
    const [formatedNewData] = useState( isMultiDBObject(newData) ? newData['item'] : newData )

    useEffect(() => {
        if(!invalidInputs)
            getFieldsWithChanges()
    },[actualData, newData])


    const getFieldsWithChanges = () => {
        let  inputs = []
        inputs = defineFieldWithChanges(model, formatedActualData, formatedNewData)

        setFieldsWithChanges( inputs )
    }

    return <>
        {
            invalidInputs ? <Alert color="warning">
                    <center>
                        <h5> ¡{ JS_INCOMPLETE_DATA }! </h5>
                    </center>
                </Alert>
            : <>
                <Row>
                    <Col sm={2}>&nbsp;</Col>
                    <Col><h3>{ JS_ACTUAL_LB }</h3><hr/></Col>
                    <Col><h3>{ JS_CAMBIOS_LB }</h3><hr/></Col>
                </Row>
                <br/>
                {
                    fieldWithChanges.map( it => it )
                }
            </>
        }
    </>
}

export default JsonCompare